export default {
  setStatuses(state, data) {
      state.statuses = data;
  },
  setFormTypeStatuses(state, data) {
    state.formTypeStatuses = data;
},
};
